import { number, oneOfType, string } from 'prop-types'
import { MenuItem } from '@mui/material'
import styled from 'styled-components'

const Option = ({ value, children, ...rest }) => {
  return (
    <StyledMenuItem value={value} {...rest}>
      {children}
    </StyledMenuItem>
  )
}

export default Option

Option.propTypes = {
  children: oneOfType([string, number]),
  value: oneOfType([string, number]),
}

// The menu is pinned to the width of its field, so a long option has to wrap
// rather than be cut off - options carry free text that tells them apart.
const StyledMenuItem = styled(MenuItem)`
  white-space: normal !important;
  overflow-wrap: break-word;
`
